import dayjs from 'dayjs';

export default {
    methods: {
        PromptSuccess(title, message) {
            this.$bvToast.toast(message, {
                title: title,
                variant: 'success',
                autoHideDelay: 10000,
                appendToast: true
            });
        },
        PromptWarning(title, message) {
            const h = this.$createElement
            const vNodesMsg = [
                h('small', dayjs().format('YYYY-MM-DD HH:mm:ss')),
                h('p', {class: ['mb-0']}, message),
            ]
            this.$bvToast.toast(vNodesMsg, {
                title: title,
                variant: 'warning',
                appendToast: true,
                'no-auto-hide': true
            });
        }
    }
};
